module.exports = __webpack_public_path__ + "static/media/Medidas_3_4_5_6_8.d9d765c9.pdf";